import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../store";
import ContactList from "./components/contactList";
import EVENT_QUERY from '../events/queries/EVENT_QUERY';
import Query from "../common/Query";
import Loading from "../common/Loading";
import JoinCTA from "../common/JoinCTA";
import EventDetail from "../events/interfaces/EventDetail";

const MailPull = () => {
  let { eventId }: { eventId?: string } = useParams();
  const { state } = useContext(AppContext);
  const isVolunteer = state.orgInfo?.volunteer_access;
  const isEC = state.orgInfo?.event_coordinator;
  const loading = state.orgInfo?.loading;
  if (isVolunteer || isEC) {
    return <><Query variables={{ eventId }} query={EVENT_QUERY}>{({ data: { event } }: { data: { event: EventDetail } }) => {
      if (!event) {
        return <span>Not Found.</span>;
      } else {
        return <ContactList event={event} />
      }
    }}
    </Query></>;
  } else {
    if (loading) {
      return <Loading />;
    } else {
      return <JoinCTA />;
    }
  }
};

export default MailPull; 